import { useCallback } from "react";
import { deleteEmail } from "../../../acions/emails";
import { useDefaultDeleteModal } from "../../../lib/hooks/defaultDeleteModal";
import MAILING_PAGES from "../../../types/enums/MailingPages";

export const useDelete = (page: MAILING_PAGES, reloadData: () => void) => {
  const { openDeleteModal } = useDefaultDeleteModal(deleteEmail, reloadData);

  const remove = useCallback(
    (id: string) => {
      openDeleteModal(
        { id, type: [2, 4].includes(page) ? 3 : 1 },
        `Delete Email from ${[MAILING_PAGES.Scheduled, MAILING_PAGES.Recurring].includes(page) ? "Scheduled" : "Outbox"}`
      );
    },
    [openDeleteModal, page]
  );

  return { remove };
};
